"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockDashboardData = exports.mockLeaderboardChallenges = exports.mockLeaderboardAssessments = exports.mockLeaderboardUsers = exports.mockLeaderboardLessons = void 0;
exports.mockLeaderboardLessons = {
    data: [
        {
            lesson_completed_at: '2022-11-08T10:49:01.000Z',
            lesson_display_name: 'Forceful Browsing',
            user_nickname: 'User1',
            image: 'https://picsum.photos/200',
        },
        {
            lesson_completed_at: '2022-11-24T14:22:19.000Z',
            lesson_display_name: 'SQL Injection',
            user_nickname: 'User1',
            image: 'https://picsum.photos/200',
        },
        {
            lesson_completed_at: '2022-11-29T09:17:34.000Z',
            lesson_display_name: 'SQL Injection',
            user_nickname: 'User2',
            image: 'https://picsum.photos/200',
        },
    ],
};
exports.mockLeaderboardUsers = {
    data: [
        {
            user_nickname: 'User1',
            points: 6000,
            image: 'https://picsum.photos/200',
        },
        {
            user_nickname: 'User2',
            points: 3000,
            image: 'https://picsum.photos/200',
        },
        {
            user_nickname: 'User3',
            points: 1000,
            image: 'https://picsum.photos/200',
        },
    ],
};
exports.mockLeaderboardAssessments = {
    result: [
        {
            uuid: '6747a603-3aa7-4124-8e77-6d2c48f78e48',
            name: 'test nir',
            start_date: '2022-11-24',
            end_date: '2022-12-03',
            topics: ['Injection', 'Sensitive Data Exposure', 'Cross Site Request Forgery', 'Cross-Site Scripting'],
            users_assessed: 0,
            users_invited: 1,
            rating: null,
        },
        {
            uuid: 'af591b02-010e-4d9f-a06c-956fc5edc059',
            name: 'test',
            start_date: '2022-09-14',
            end_date: '2022-09-14',
            topics: ['Injection', 'Sensitive Data Exposure', 'Cross Site Request Forgery', 'Cross-Site Scripting'],
            users_assessed: 0,
            users_invited: 0,
            rating: null,
        },
        {
            uuid: 'a42c9186-da56-445f-95fc-3b6bb868bae9',
            name: 'Simba',
            start_date: '2022-08-29',
            end_date: '2022-12-23',
            topics: [
                'Injection',
                'Broken Authentication and Session Management',
                'Sensitive Data Exposure',
                'Cross Site Request Forgery',
                'Broken Access Control',
                'User Interface Security Issues',
                'Unvalidated Redirects and Forwards',
                'Cross-Site Scripting',
                'Insecure Deserialization',
                'XML External Entities (XXE)',
                'Using Components with Known Vulnerabilities',
            ],
            users_assessed: 0,
            users_invited: 1,
            rating: null,
        },
        {
            uuid: 'fc7ce5af-53cc-42c9-a5b1-a3f25ed62978',
            name: 'Codebashing Simba',
            start_date: '2022-08-29',
            end_date: '2023-01-11',
            topics: ['Injection', 'Sensitive Data Exposure', 'Cross Site Request Forgery', 'Cross-Site Scripting'],
            users_assessed: 1,
            users_invited: 1,
            rating: 50.0,
        },
        {
            uuid: '9b50e8f7-ec52-4e55-a1c8-d70bd5af34c9',
            name: 'Test #1',
            start_date: '2022-08-29',
            end_date: '2023-03-15',
            topics: [
                'Injection',
                'Broken Authentication and Session Management',
                'Sensitive Data Exposure',
                'Cross Site Request Forgery',
                'Broken Access Control',
                'User Interface Security Issues',
                'Unvalidated Redirects and Forwards',
                'SSRF',
                'Race Condition',
                'Unrestricted File Upload',
                'Cross-Site Scripting',
                'Insecure Deserialization',
                'XML External Entities (XXE)',
                'Insecure Memory Operation',
                'Using Components with Known Vulnerabilities',
                'Security Misconfiguration',
            ],
            users_assessed: 1,
            users_invited: 1,
            rating: 26.0,
        },
    ],
};
exports.mockLeaderboardChallenges = {
    data: [
        {
            points: 1200,
            user_nickname: 'User1',
            image: 'https://picsum.photos/200',
            game_name: 'Challenge 1',
        },
        {
            points: 600,
            user_nickname: 'User2',
            image: 'https://picsum.photos/200',
            game_name: 'Challenge 2',
        },
        {
            points: 500,
            user_nickname: 'User3',
            image: 'https://picsum.photos/200',
            game_name: 'Challenge 3',
        },
    ],
};
exports.mockDashboardData = {
    lessons: [
        {
            started_at: '2022-11-28T10:32:05.000Z',
            completed_at: null,
            description: 'Forceful (or forced) browsing is a common attack technique used to gain access to web server resources that are restricted, or resources that are accessed outside of the intended (correct) sequence. An attacker carries out the attack by guessing, knowing or inferring the correct URL directly. If the restricted URLs, scripts, or files that reside in the web server directory are not enforced with appropriate authorization or sequencing logic, they can be vulnerable to forceful browsing attacks.',
            title: 'Forceful Browsing',
            icon_url: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/android/icons/forceful_browsing.png',
            lesson_name: 'forceful_browsing',
            course_name: 'ios',
        },
        {
            started_at: '2022-11-29T09:21:36.000Z',
            completed_at: null,
            description: 'SQL Injection is a type of application security vulnerability whereby a malicious user is able to manipulate the SQL statements that the application sends to the backend database server for execution. A successful SQL injection attack exposes the data of the underlying database directly to the attacker. Play and Learn...',
            title: 'SQL Injection',
            icon_url: null,
            lesson_name: 'sql_injection',
            course_name: 'dotnet',
        },
    ],
    weekly_challenge: { id: 14, level: 'Intermediate', language: 'Python Django' },
    team_id: 10,
};
